import DOMPurify from 'dompurify';
import { Marked } from 'marked';

const marked = new Marked({ gfm: true, breaks: true, async: false });

const ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};
export const escapeHtml = (s: string) => s.replace(/[&<>"']/g, (c) => ESCAPES[c]!);

/** Lo único que puede quedar del HTML que arma `marked`: sin imágenes, iframes ni atributos raros. */
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'code',
  'pre',
  'ul',
  'ol',
  'li',
  'a',
  'blockquote',
  'h1',
  'h2',
  'h3',
  'h4',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'sup',
  'hr',
  'del',
];

/**
 * Markdown de la respuesta → HTML sanitizado. Las citas `[n]` quedan como `<sup>` (o se sacan, con
 * `citations: false`, cuando el sistema no muestra las fuentes) y los links se abren en otra
 * pestaña. El texto viene del LLM: nunca se inserta sin pasar por DOMPurify.
 */
export function renderMarkdown(markdown: string, { citations = true } = {}): string {
  // Sin DOM compatible, DOMPurify devuelve el HTML tal cual: mejor mostrar el texto escapado.
  if (!DOMPurify.isSupported) return escapeHtml(markdown).replace(/\n/g, '<br>');
  const html = marked.parse(markdown) as string;
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'start'],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
  });
  const withLinks = clean.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
  // Solo dígitos entre corchetes: no puede meter HTML. El número lo dibuja el CSS (`data-n`), así
  // no queda en el texto que se copia.
  return withLinks.replace(
    /\s*\[(\d+)\]/g,
    citations ? '<sup class="cite" data-n="$1" title="Fuente $1"></sup>' : '',
  );
}
